
import { useState, useEffect } from 'react';
import { getPetById } from '../services/petsService';
import { useToast } from '@/hooks/use-toast';

export const usePet = (petId: string | undefined) => {
  const [pet, setPet] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    if (!petId || petId === 'undefined') {
      setIsLoading(false);
      setError(new Error('Pet ID is required'));
      return;
    }

    const fetchPet = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getPetById(petId);
        setPet(data);
      } catch (err: any) {
        setError(err);
        toast({
          title: "Error",
          description: `Failed to load pet: ${err.message}`,
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPet();
  }, [petId, toast]);

  return { pet, isLoading, error };
};
